


















































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { TagContentsParam } from "@/params/TagContentsParam";
import DialogCloseNavigation from "@/components/navigations/DialogCloseNavigation.vue";

@Component({
  components: {DialogCloseNavigation}
})
export default class VrTagImageDialog extends Vue {
  @Prop() isShown: boolean;
  @Prop() contents: TagContentsParam;

  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  get parentDom (): HTMLDivElement {
    const $parent: HTMLDivElement = <HTMLDivElement> this.$parent.$el;
    return $parent;
  }

  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      this.onCloseDialog();
    }
  }

  @Emit('close')
  onCloseDialog (): void {}
}
